import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { IPartnerContact } from './model/types'

export interface IContactsState {
  data: IPartnerContact[]
  isLoading: boolean
  status: RequestStatus
  error: string | null
  partnerId: string | null
  programType: ProgramTypes | null
}

export const initialState: IContactsState = {
  data: [],
  isLoading: false,
  status: RequestStatus.NONE,
  error: null,
  partnerId: null,
  programType: null,
}
